var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ed-email',{key:_vm.$root.$session.versao,attrs:{"intCabecalhoMovimentoId":_vm.$route.params.intId,"intMovimentoId":_vm.$route.params.intMovimentoId,"intTipoMovimentoId":1444}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }